// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-card[data-v-d6b3538a]{font-size:20px}.text-card[data-v-d6b3538a],.title-card[data-v-d6b3538a]{color:#212529;font-family:Trebuchet MS,sans-serif}.text-card[data-v-d6b3538a]{font-size:12px}", ""]);
// Exports
module.exports = exports;
